import HeaderMenu from './HeaderMenu'

export default function HeaderDesktop() {
  return (
    <ul className="hidden w-full xl:items-center xl:justify-end xl:flex gap-1 xl:gap-3 2xl:gap-4 xl:px-6 relative">
      <HeaderMenu setMobileMenuOpen={() => null} />
    </ul>
  )
}
